// src/components/common/Footer.jsx
import React from "react";
import { FaFacebookF, FaLinkedinIn, FaInstagram, FaYoutube } from "react-icons/fa";
import { useTheme } from "../../contexts/ThemeContext";

const Footer = () => {
  const { theme, domains } = useTheme();

  return (
    <footer className="w-full mb-12 py-8 px-4 sm:px-6">
      <div
        className={`max-w-7xl mx-auto p-8 sm:p-12 h-auto sm:h-[490px] rounded-3xl shadow-sm 
          ${theme.bgColor} ${theme.backdrop}`}
      >
        <div className="flex flex-col md:flex-wrap md:flex-row justify-between items-start gap-8 px-4 sm:px-28">
          {/* LOGO */}
          <div className="flex flex-col items-start min-w-[200px] mb-8 md:mb-0">
            <p className={`font-bold text-3xl mb-4 ${theme.textColor}`}>
              BIANCO AZURE
            </p>
            {theme.context && (
              <p className={`text-sm ${theme.textColor}`}>
                {theme.context.toUpperCase()}
              </p>
            )}
          </div>

          {/* PÁGINAS */}
          <div className="min-w-[120px]">
            <p className={`text-sm mb-4 ${theme.textColor}`}>Páginas</p>
            <ul className={`space-y-2 text-xs ${theme.navTextColor}`}>
              <li>
                <a
                  href={`${domains.institucional}`}
                  rel="noopener noreferrer"
                  className={`${theme.navTextColor}`}
                >
                  Home Principal
                </a>
              </li>
              <li>
                <a
                  href={`${domains.institucional}/sobre`}
                  rel="noopener noreferrer"
                  className={`${theme.navTextColor}`}
                >
                  Sobre Nós
                </a>
              </li>
              <li>
                <a
                  href={`${domains.institucional}/blog`}
                  rel="noopener noreferrer"
                  className={`${theme.navTextColor}`}
                >
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* SERVIÇOS */}
          <div className="min-w-[120px]">
            <p className={`text-sm mb-4 ${theme.textColor}`}>Serviços</p>
            <ul className={`space-y-2 text-xs ${theme.navTextColor}`}>
              <li>
                <a
                  href={`${domains.auditivo}`}
                  rel="noopener noreferrer"
                  className={`${theme.navTextColor}`}
                >
                  Aparelhos Auditivos
                </a>
              </li>
              <li>
                <a
                  href={`${domains.respiratorio}`}
                  rel="noopener noreferrer"
                  className={`${theme.navTextColor}`}
                >
                  Equipamentos Respiratórios
                </a>
              </li>
              <li>
                <a
                  href={`${domains.homecare}`}
                  rel="noopener noreferrer"
                  className={`${theme.navTextColor}`}
                >
                  Home Care
                </a>
              </li>
            </ul>
            <p className={`mt-4 text-xs sm:text-xs ${theme.navTextColor}`}>
              CNPJ: 17.718.423/0001-03
            </p>
          </div>

          {/* CONTATO */}
          <div className="min-w-[200px]">
            <p className={`text-sm mb-4 ${theme.textColor}`}>Contato</p>
            <ul className={`space-y-2 text-sm ${theme.navTextColor}`}>
              <li className="flex flex-col">
                <p className="text-[10px]">Ribeirão Preto - SP</p>
                <a href="tel:+551634424470" className={theme.navTextColor}>
                  (16) 3442-4470
                </a>
              </li>

              <li className="flex flex-col">
                <p className="text-[10px]">Campinas - SP</p>
                <a href="tel:+551633256912" className={theme.navTextColor}>
                  (19) 3325-6912
                </a>
              </li>

              <li className="flex flex-col">
                <p className="text-[10px]">São José do Rio Preto - SP</p>
                <a href="tel:+551633633749" className={theme.navTextColor}>
                  (17) 3363-3749
                </a>
              </li>

              <li>
                <a
                  href="mailto:contato@grupobiancoazure.com.br"
                  className={theme.navTextColor}
                >
                  contato@grupobiancoazure.com.br
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* DIREITOS AUTORAIS E REDES SOCIAIS */}
        <div
          className={`mt-12 pt-6 flex flex-col md:flex-row justify-between 
            h-auto md:h-36 items-center gap-4 border-t-2 px-4 sm:px-28 
            ${theme.textColor}/40`}
        >
          <p className={`text-xs text-center md:text-left ${theme.textColor}`}>
            © BIANCO AZURE 2025 - todos os direitos reservados
          </p>

          <div className="flex space-x-2 mt-4 md:mt-0">
            <a
              href="https://www.facebook.com/biancoazure"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className={`${theme.buttonBg} ${theme.buttonHoverBg} p-2 rounded transition-colors`}
            >
              <FaFacebookF className="w-4 h-4 text-white" />
            </a>

            <a
              href="https://br.linkedin.com/company/bianco-azure-equipamentos-m%C3%A9dicos"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className={`${theme.buttonBg} ${theme.buttonHoverBg} p-2 rounded transition-colors`}
            >
              <FaLinkedinIn className="w-4 h-4 text-white" />
            </a>

            <a
              href="https://www.instagram.com/biancoazure"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className={`${theme.buttonBg} ${theme.buttonHoverBg} p-2 rounded transition-colors`}
            >
              <FaInstagram className="w-4 h-4 text-white" />
            </a>

            <a
              href="https://www.youtube.com/@biancoazure"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              className={`${theme.buttonBg} ${theme.buttonHoverBg} p-2 rounded transition-colors`}
            >
              <FaYoutube className="w-4 h-4 text-white" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;